import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import {
  navigateToSummaryArchive,
  isMetricLinkable,
  resolveMetricKeyFromCardKey,
  buildTransferMatrixArchiveNavigation,
  SUMMARY_REPORT_ARCHIVE_STORAGE_KEY,
} from '../helpers/summaryReportArchiveHelper';

export const useSummaryReportArchive = () => {
  const router = useRouter();
  const { t } = useI18n();
  const accountId = useMapGetter('getCurrentAccountId');

  const openArchive = async ({
    metricKey,
    reportType,
    row,
    context,
    filters,
    ratings,
    csatResponded,
    durationMin,
    durationMax,
    durationEvent,
  }) => {
    const opened = await navigateToSummaryArchive(router, {
      accountId: accountId.value,
      metricKey,
      reportType,
      row,
      context,
      filters,
      ratings,
      csatResponded,
      durationMin,
      durationMax,
      durationEvent,
    });
    if (opened === false) {
      useAlert(t('REPORT.ARCHIVE_NAVIGATION_FAILED'));
    }
  };

  const openTransferMatrixArchive = ({ fromTeam, toTeam, context }) => {
    const navigation = buildTransferMatrixArchiveNavigation({
      accountId: accountId.value,
      fromTeam,
      toTeam,
      context,
    });
    if (!navigation) return;

    sessionStorage.setItem(
      SUMMARY_REPORT_ARCHIVE_STORAGE_KEY,
      JSON.stringify({
        filters: navigation.filters,
        chatStatus: navigation.chatStatus,
      })
    );
    router.push(navigation.route);
  };

  return {
    openArchive,
    openTransferMatrixArchive,
    isMetricLinkable,
    resolveMetricKeyFromCardKey,
  };
};
